import Settings from "./Settings";
import { AuthToken } from "./AuthToken";

import ProcessingResult from "../framework/ProcessingResult";

import GetDatabasesResult from "../classes/api/result/datastructuremodule/GetDatabasesResult";
import CreateDatabaseResult from "../classes/api/result/datastructuremodule/CreateDatabaseResult";
import DatabaseReferenceIdAndKeyDto from "../classes/dtos/DatabaseReferenceIdAndKeyDto";

const DatabaseApi = {

    GetDatabasesAsync: async function (dataSourceId: number, forceUpdate: boolean): Promise<ProcessingResult<GetDatabasesResult>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/Database/GetDatabases?DataSourceId=" + dataSourceId.toString() + "&ForceUpdate=" + forceUpdate.toString(), {
            method: "Get",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            }
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(new GetDatabasesResult(data.accepted, data.status, data.lastUpdateDate, data.databases.map((e: any) => new DatabaseReferenceIdAndKeyDto(e.id, e.key, e.name))));
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    CreateDatabaseAsync: async function (dataSourceId: number, databaseName: string): Promise<ProcessingResult<CreateDatabaseResult>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/Database/CreateDatabase", {
            method: "Post",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            },
            body: JSON.stringify({
                'dataSourceId': dataSourceId,
                'databaseName': databaseName
            })
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(new CreateDatabaseResult(data.accepted, data.status, data.errorMessage));
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    }
};

export default DatabaseApi;